module.exports = __webpack_public_path__ + "media/images/athletes/3434-8c0496bbb4c8b63382c185b3810d04d0.png";